import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';

import { PurchaseOrderService, PurchaseOrderFilter, PurchaseOrderId } from '../../services/purchase-order.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { Subscription } from 'rxjs';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { FiscalDataService } from '../../services/fiscal-data.service';
import { Utils } from '../../util';

@Component({
  selector: 'app-read-purchase-order',
  templateUrl: './read-purchase-order.component.html',
  styleUrls: ['./read-purchase-order.component.css']
})
export class ReadPurchaseOrderComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};
  
  editingId: string = '';

  modalActionsSupplier = new EventEmitter<string|MaterializeAction>();
  modalParamsSupplier = [{dismissible: true}];

  suppliers = {};
  suppliersInit: any;

  purchaseOrders:any[] = [];
  fromWhere: string;

  purchaseOrderSub: Subscription;
  supplierSub: Subscription;
  fiscalDataSub: Subscription;
  settingsSub: Subscription;

	data:Array<any>;
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Folio', name: 'name',sort: 'asc'},
    {title: 'Proveedor', className: 'center', name: 'supplierName'},
    {title: 'Fecha' , className: 'center', name: 'date'},
    {title: 'Proyectos', className: 'center', name: 'odpNames'},
    {title: 'Clientes', className: 'center', name: 'customerNames'},
    {title: 'Productos', className: 'center', name: 'prNum'},
    {title: 'Entregados', className: 'center', name: 'inWare'},
    {title: 'Cancelado', className: 'center', name: 'canceled_icon'},
    {title: 'Acciones', className: 'center minFourButtons',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
      { name: 'clear', title: '', styleIcon: 'clear', action: 'onCancel', styleClass: 'btn-floating btn waves-effect red lighten-1' },
			{ name: 'account_circle', title: '', styleIcon: 'account_circle', action: 'onSupChange', styleClass: 'btn-floating btn waves-effect light-blue darken-1' },
			{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit', styleClass: 'btn-floating btn waves-effect light-green darken-1' },
			{ name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete', styleClass: 'btn-floating btn waves-effect red darken-2', }
		] } }
  ];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
		api: {
      onCancel: this.openModalCancel.bind(this),
      onSupChange: this.onSupChange.bind(this),
			onEdit: this.onEdit.bind(this),
			onDelete: this.onDelete.bind(this)
		}
  };

  constructor(
    private service: PurchaseOrderService,
    private supplierService: CustomerSupplierService,
    private fiscalDataService: FiscalDataService,
    private settings: CatalogsSettingsService,
    private fb: FormBuilder,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else this.allowed = true;
    });

    
    this.settingsSub = this.settings.getPayrollSettings('1').subscribe(setting => {
      this.settingsSub.unsubscribe();
      this.itemsPerPage = setting.tableQuantity;
    });

    this.loadPurchaseOrders(15);
    
    this.supplierSub = this.supplierService.getSuppliers().subscribe(suppliers => {
      this.readObjs[0] = {};
      this.rowsRead[0] = suppliers.map(supplier => {
        supplier.id = supplier.id$;
        this.readObjs[0][supplier.id] = {...supplier};
        return supplier;
      });
    });
    this.fiscalDataSub = this.fiscalDataService.getAllFiscalDatas().subscribe(fiscalDatas => {
    this.readObjs[1] = {};
      this.allFiscalRows = fiscalDatas.filter(fiscalData => {
        fiscalData.name = fiscalData.rfc;
        this.readObjs[1][fiscalData.id] = {...fiscalData};
        if(fiscalData.supplierId) return fiscalData;
      });
    });
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    this.purchaseOrderSub.unsubscribe();
    this.supplierSub.unsubscribe();
    this.fiscalDataSub.unsubscribe();
  }

  loadPurchaseOrders(days=undefined){
    if(this.purchaseOrderSub) this.purchaseOrderSub.unsubscribe();
		this.purchaseOrderSub = this.service.getPurchaseOrders({filterDays: days}).subscribe(tempPurchaseOrders => {
			this.purchaseOrders = [];
			for (const idx in tempPurchaseOrders) {
        const u = tempPurchaseOrders[idx];
        u.name = u.folio;
        u.supplierName = u.supplierObj.name;
        u.prNum = u.prForOrders.length;
        u.odpNames = u.prForOrders.reduce((acc, {odpName=''}, index) => {
          return odpName ? `${acc}${index ? index%3 == 0 ? ',<br>' : ',' : ''}${odpName}` : ''
        }, '');
        u.customerNames = u.prForOrders.map(({customerName=''}) => customerName).filter(d => d);
        u.inWare = `${u.prForOrders.reduce((acc, {inWareQuantity=0}) => acc + inWareQuantity, 0)}/${u.prForOrders.reduce((acc, {quantity=0}) => acc + quantity, 0)}`;
        u.cancelable = true;
        for(let pr of u.prForOrders) if((pr.inWareQuantity || 0) > 0 || (pr.billedQuantity || 0) > 0) u.cancelable = false;
        u.canceled_icon = u.canceled ? `<i class="small material-icons">done</i>` : `<i class="small material-icons">clear</i>`;
				this.purchaseOrders.push(u);
      }
      
      this.filterBar = new PurchaseOrderFilter(this.purchaseOrders, days ? {} : JSON.parse(this.filterBar.json));
      this.applyFilterBar();
    });
  }

  deletePurchaseOrder(sid: string) {
    this.service.deletePurchaseOrder(sid);
  }
  onCellClick(data: any): any {
		this.router.navigate(['/vw_purchase_order/' + data.row.id + '/fromOrder']);
  }

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.editingId = '';
    this.selectedIds = [];
    this.continueReadTo(0);
  }

  onSupChange({row: odc}){
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
    this.editingId = odc.id;
    this.selectedIds = [];
    this.continueReadTo(0);
  }

	onEdit(data: any) {
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
    if(data.row.canceled) return toast('No se puede editar después de ser cancelado.', 2000);
		this.router.navigate(['/edit_purchase_order/', data.row.id]);
  
  }
	onDelete(data: any) {
    if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
		this.deletePurchaseOrder(data.row.id);
  
  }
  viewPurchaseOrder(id: string){
    this.router.navigate(['/vw_purchase_order/' + id]);
  }

  reasonMsg: string = '';
  cancelingOdc: PurchaseOrderId = null;
  async continueCancel(){
    if(!this.reasonMsg) return toast('Ingrese una justificación.', 2000);
    try{
      let data: Partial<PurchaseOrderId> = {
        canceled: true,
        cancelReasons: [
          ...(this.cancelingOdc.cancelReasons || []),
          {datetime: `${Utils.today}, ${Utils.time}`, msg: this.reasonMsg},
        ],
      };
      await this.service.updatePurchaseOrder(this.cancelingOdc.id, data);
      this.reasonMsg = '';
      this.closeModalCancel();
      toast('Éxito', 2000);
    }catch(error){
      toast('Error inesperado.', 2000);
    }
  }

  ////////////////////////////////////////////////////////////////////Cancel
  modalActionsCancel = new EventEmitter<string|MaterializeAction>();
  modalParamsCancel = [{dismissible: true}];
  openModalCancel({row: odc}: {row: PurchaseOrderId}) {
    this.cancelingOdc = odc;
    this.modalActionsCancel.emit({ action: 'modal', params: ['open'] });
  }
  closeModalCancel() {
    this.modalActionsCancel.emit({ action: 'modal', params: ['close'] });
  }
  ////////////////////////////////////////////////////////////////////Cancel

  ////////////////////////////////////////////////////////////////////FilterBar
  receivedAll: boolean = false;
  filterBar: PurchaseOrderFilter = new PurchaseOrderFilter([],{});
  applyFilterBar(){
    //localStorage.quotRead = this.filterBar.json;

    this.data = this.filterBar.filteredData;
    this.length = this.data.length;
    this.onChangeTable(this.config);
  }
  onChangeDateFilterBar(){
    if(this.filterBar.dateIndex && !this.receivedAll){
      this.loadPurchaseOrders();
      this.receivedAll = true;
    }else{
      this.applyFilterBar();
    }
  }
  ////////////////////////////////////////////////////////////////////FilterBar
  
  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }
    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }


  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    this.selectedIds[this.currentReadIndex] = data.row.id;
    if(this.readValid) this.continueReadTo(this.currentReadIndex + 1);
  }
  continueReadTo(nextIndex){
    if(nextIndex == this.columnsRead.length){
      let [supplierId, fiscalDataId] = this.selectedIds;
      this.closeModalRead();
      if(!this.editingId) this.router.navigate([`/new_purchase_order/${supplierId}_${fiscalDataId}/noReq`]);
      else{
        this.service.updateSupplierAndFiscal(this.editingId, {supplierId, fiscalDataId});
        toast('Se cambió el proveedor.', 3000);
      }
    }else{
      if(nextIndex == 1) this.rowsRead[nextIndex] = this.allFiscalRows.filter(fiscalRow => fiscalRow.supplierId && fiscalRow.supplierId == this.selectedIds[0]);
      this.currentReadIndex = nextIndex;
      this.r_data = this.rowsRead[nextIndex];
      this.r_config = this.r_configs[nextIndex];
      this.r_page = 1;
      this.r_onChangeTable(this.r_config);
      if(nextIndex == 0) this.openModalRead();
    }
  }
  goBackReadTo(prevIndex){
    if(prevIndex < 0){
      this.closeModalRead();
    }else{
      this.selectedIds[prevIndex + 1] = '';
      this.currentReadIndex = prevIndex;
      this.r_data = this.rowsRead[prevIndex];
      this.r_config = this.r_configs[prevIndex];
      this.r_onChangeTable(this.r_config);
    }
  }

  selectedIds: string [] = [];
  readObjs: any[] = [];
  subs: any[] = [];
  readPlaceholders = [ 'un proveedor', 'sus datos fiscales' ]
  get readValid(){ return !!this.selectedIds[this.currentReadIndex] };
  currentReadIndex: number;
  allFiscalRows: any;
  rowsRead = [[], []];
  columnsRead = [
    [//supplier
      { title: 'Nombre', name: 'name', sort: 'asc' },
      { title: 'Descripción', name: 'description' },
      { title: 'Correo electrónico', name: 'email' }
    ],
    [
      { title: 'RFC', name: 'name', sort: 'asc' },
      { title: 'Razón Social', name: 'businessName' }
    ]
  ]


  r_data:Array<any>;
  r_rows:Array<any> = [];
  r_page:number = 1;
  r_itemsPerPage:number = 5;
  r_maxSize:number = 5;
  r_numPages:number = 1;
  r_length:number = 0;

  
  r_configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));
  r_config = this.r_configs[0];

  /*********** Filter, sort, and pagination */

	r_changePage(page:any, data:Array<any> = this.r_data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  r_changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.r_config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }
    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  r_changeFilter(data:any, config:any):any {
    //console.clear();
    console.log(this.columnsRead[this.currentReadIndex])
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });
    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.r_config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  r_onChangeTable(config:any, page:any = {page: this.r_page, itemsPerPage: this.r_itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.r_config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.r_config.sorting, config.sorting);
    }

    let filteredData = this.r_changeFilter(this.r_data, this.r_config);
    let sortedData = this.r_changeSort(filteredData, this.r_config);
    this.r_rows = page && config.paging ? this.r_changePage(page, sortedData) : sortedData;
    this.r_length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}